import {
  ZFE_API_SCHEMA_KEYS,
  ZFE_CORPORATE_DASHBOARD_TRACKING_KEYS,
  WEB_SCHEMA_KEYS,
  ZfeCorporateDashboardTrackingKeys,
} from './Constants';

import { getBrowserAndVersion } from '../helpers';
import {
  schemaKeyValidator,
  validateAndRectifyTrackingData,
} from './Validators';

export const BuildCorporateDashboardTracking = data => {
  Object.keys(data).forEach(key => {
    if (
      !schemaKeyValidator(ZFE_CORPORATE_DASHBOARD_TRACKING_KEYS, key) &&
      !schemaKeyValidator(WEB_SCHEMA_KEYS, key) &&
      !schemaKeyValidator(ZFE_API_SCHEMA_KEYS, key)
    ) {
      throw new Error(
        `Invalid key ${key} provided. Please use one of the following keys: ${Array.from(
          WEB_SCHEMA_KEYS,
        ).join(', ')}, ${Array.from(ZFE_CORPORATE_DASHBOARD_TRACKING_KEYS).join(
          ', ',
        )}, ${Array.from(ZFE_API_SCHEMA_KEYS).join(', ')}`,
      );
    }
  });
  return validateAndRectifyTrackingData(ZfeCorporateDashboardTrackingKeys)(
    data,
  );
};

export const appLoadData = () => {
  const data = window?.navigator || {};
  return {
    connectionType: data?.connection?.effectiveType || '',
    url: window?.location?.href || '',
    ...getBrowserAndVersion(),
  };
};
